module.exports = __webpack_public_path__ + "static/media/rewards.1a7e7717.png";